import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import baseURL, { appName } from "../../../configs/api";
import SignatureCanvas from "react-signature-canvas";
import { Button, CircularProgress, Divider } from "@mui/material";
import useAuth from "../../../components/hooks/useAuth";
import AdjustmentList from "../../../components/common/AdjustmentList2";
import AddAdjustmentModal from "../../../components/common/AddAdjustmentModal2";
import AddExtensionModal from "../../../components/common/AddExtensionModal2";
import ExtensionList from "../../../components/common/ExtensionList2";
import { getReservationExtensionByReservationId } from "../../../services/Extension";
import AddReplaceVehicleModal from "../../../components/common/AddReplaceVehicleModal2";
import VehicleReplaceList from "../../../components/common/VehicleReplaceList2";
import AddEarlyReturnModal from "../../../components/common/AddEarlyReturnModal2";
import EarlyReturnList from "../../../components/common/EarlyReturnList2";
import { getEarlyReturnByReservationId } from "../../../services/earlyReturn";
import { getVehicleReplaceReportByReservationId } from "../../../services/VehicleReplcae";
import { delete_fileUpload } from "../../../services/appFileUpload";
import { branchTimezone } from "../../../utils/summaryCalculation";
import useAccessControl from "../../../components/hooks/useAccessControl";
import useConfirm from "../../../components/hooks/useConfirm";
import UpdateLocationModal from "../../../components/common/UpdateLocationModal2";
import { jsPDF } from "jspdf";
import { useTheme } from "../../../components/hooks/useTheme";
import colorConfigs from "../../../configs/colorConfigs";
import '../../../styles/RentalAgreementView.css'
import { confirmAgreement, disableRenewal } from "../../../services/rental";
import Cookies from "js-cookie";
import ShareLocationRequest from "./ShareLocationRequest";
import { getDisabledVehicleLocationsByReservationId } from "../../../services/DisabledVehicleLocation";
import DisabledVehicleLocationList from "../../../components/common/DisabledVehicleLocationList";
import useTenant from "../../../components/hooks/useTenant";


type AgreementProps = {
  summaryData: any;
  customerPhoneNumber: string;
  formattedCreatedAt: string;
  signatureURL: any;
  setSignatureURL: (value: any) => void;
  initialsURL: any;
  setInitialsURL: (Value: any) => void;
  extraValue: any[];
  selectedVehicleClass: any;
  reservationAdditionalCharge: any[];
  isCompletedOrCancelled: boolean,
  getDataFromExtras: (extraValue: any[]) => void;
  refreshTheSummary: () => void;
  refreshTheAdjustment: () => void;
  currentPage: string;
  locationOptions: any[];
  locationOpenHourOfParticularBranch: any[];
  availableVehicle: any[];
  returnLocationOptionsOfParticularBranch: any[];
  bookedVehicleData: any | null;
  checkInFiles: any[];
  vehicleReplacementCheckOutFiles: any[];
  vehicleReplacementCheckInFiles: any[];
  checkOutFiles: any[]; reservationId: number;
  refreshTheAttachement: () => void;
  preferredDateFormat: string;
  setAvailableVehicle: (value: any[]) => void;
  setPleaseWaitPopup: (value: boolean) => void;
};


export const Agreement = ({
  summaryData,
  customerPhoneNumber,
  formattedCreatedAt,
  signatureURL,
  setSignatureURL,
  initialsURL,
  setInitialsURL,
  extraValue,
  selectedVehicleClass,
  reservationAdditionalCharge,
  isCompletedOrCancelled,
  getDataFromExtras,
  refreshTheSummary,
  refreshTheAdjustment,
  currentPage,
  locationOptions,
  locationOpenHourOfParticularBranch,
  availableVehicle,
  returnLocationOptionsOfParticularBranch,
  bookedVehicleData,
  checkInFiles,
  checkOutFiles,
  vehicleReplacementCheckOutFiles,
  vehicleReplacementCheckInFiles,
  reservationId,
  refreshTheAttachement,
  preferredDateFormat,
  setAvailableVehicle,
  setPleaseWaitPopup
}: AgreementProps) => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { permissions }: any = useAccessControl();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [addEarlyReturnIsOpen, setAddEarlyReturnIsOpen] = useState<boolean>(false);
  const [adjustmentIsOpen, setAdjustmentIsOpen] = useState<boolean>(false);
  const [addExtensionIsOpen, setAddExtensionIsOpen] = useState<boolean>(false);
  const [extensionData, setExtensioData] = useState<any[]>([]);
  const [extensionRefresh, setExtensionRefresh] = useState<boolean>(true);
  const [replaceVehicleIsOpen, setReplaceVehicleIsOpen] = useState<boolean>(false);
  const [vehicleReplaceReport, setVehicleReplaceReport] = useState<any[]>([]);
  const [vehicleReplaceRefresh, setVehicleReplaceRefresh] = useState<boolean>(true);
  const [earlyReturnRefresh, setEarlyReturnRefresh] = useState<boolean>(true);
  const [earlyReturnData, setEarlyReturnData] = useState<any[]>([]);
  const [updateLocationIsOpen, setUpdateLocationIsOpen] = useState<boolean>(false);
  const [shareLocationIsOpen, setShareLocationIsOpen] = useState<boolean>(false);
  const [shareLocationRefresh, setShareLocationRefresh] = useState<boolean>(true);
  const [disabledVehicleLocationData, setDisabledVehicleLocationData] = useState<any[]>([]);

  let signaturePadRef = React.useRef<SignatureCanvas>(null);
  let initialsPadRef = React.useRef<SignatureCanvas>(null);

  const [isLoadingTheRentalAgrement, setIsLoadingTheRentalAgrement] = useState<boolean>(false);
  const htmlRef = useRef<HTMLDivElement | null>(null);

  const UpdateTimezone = branchTimezone(formattedCreatedAt);

  const signatureFileRef = useRef<HTMLInputElement>(null);
  const onSignatureFileChangeCapture = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);
      const selectedFiles = e.target.files as FileList;

      if (selectedFiles.length !== 0) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);

        axios
          .post(`${baseURL}reservationFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {
            const newFilePath: any = {
              id: 0,
              fileName: response.data,
            };
            signaturePadRef.current?.clear();
            setSignatureURL(newFilePath);
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
      }
    }
  };
  const initialsFileRef = useRef<HTMLInputElement>(null);
  const onInitialsFileChangeCapture = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);
      const selectedFiles = e.target.files as FileList;

      if (selectedFiles.length !== 0) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);

        axios
          .post(`${baseURL}reservationFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {
            const newFilePath: any = {
              id: 0,
              fileName: response.data,
            };

            initialsPadRef.current?.clear();
            setInitialsURL(newFilePath);
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
      }
    }
  };

  useEffect(() => {
    if (currentPage === 'Agreement') {
      setVehicleReplaceRefresh(true);
      setEarlyReturnRefresh(true);
      setExtensionRefresh(true);
    }
  }, [currentPage])

  useEffect(() => {
    if (reservationId > 0 && vehicleReplaceRefresh) {
      getVehicleReplaceReportByReservationId(reservationId, tenantId)
        .then((data) => {
          setVehicleReplaceReport(data);
          setVehicleReplaceRefresh(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setVehicleReplaceRefresh(false);
          setVehicleReplaceReport([]);
          handleTenantError(error);
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId, vehicleReplaceRefresh])

  useEffect(() => {
    if (reservationId > 0 && extensionRefresh && currentPage === 'Agreement') {
      getReservationExtensionByReservationId(reservationId, tenantId)
        .then((res) => {
          setExtensioData(res);
          setExtensionRefresh(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setExtensionRefresh(false);
          setExtensioData([]);
          handleTenantError(error);
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId, extensionRefresh, currentPage])

  useEffect(() => {
    if (reservationId > 0 && earlyReturnRefresh && currentPage === 'Agreement') {
      getEarlyReturnByReservationId(reservationId, tenantId)
        .then((res) => {
          setEarlyReturnData(res);
          setEarlyReturnRefresh(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setEarlyReturnData([]);
          handleTenantError(error);
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId, earlyReturnRefresh, currentPage])


  useEffect(() => {
    if (reservationId > 0 && shareLocationRefresh && currentPage === 'Agreement') {
      getDisabledVehicleLocationsByReservationId(reservationId, tenantId)
        .then((res) => {       
          setDisabledVehicleLocationData(res);
          setShareLocationRefresh(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setDisabledVehicleLocationData([]);
          handleTenantError(error);
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId, shareLocationRefresh, currentPage])


  useEffect(() => {
    async function fetchAndConvertPdf() {
      try {
        setIsLoadingTheRentalAgrement(false);

        const response = await axios.get(
          `${baseURL}rentalAgreementPdf?reservationId=${reservationId}`,
          {
            responseType: 'text', // Fetching HTML content (not binary data)
            headers: {
              'X-Tenant-ID': tenantId,
            }
          }
        );

        const getImageBase64 = async (imgURL: string) => {
          const response = await fetch(imgURL);
          const blob = await response.blob();
          const reader = new FileReader();

          return new Promise((resolve, reject) => {
            reader.onloadend = () => {
              resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        };

        const doc = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
          compress: true
        });

        // Set PDF properties
        doc.setProperties({
          title: `RentalAgreement${reservationId}.pdf`,
          author: summaryData?.createdBy,
          subject: "Rental Agreement",
          keywords: "rental, agreement",
          creator: appName
        });

        let base64Image: string | null = null;
        if (initialsURL?.fileName) {
          const imgURL = `${baseURL}reservationFile/Get?name=${initialsURL?.fileName}`;
          base64Image = await getImageBase64(imgURL) as string;
        }

        const addFooterImage = (doc: jsPDF, base64Image: string | null) => {
          if (base64Image) {
            const pageHeight = doc.internal.pageSize.height;
            const pageWidth = doc.internal.pageSize.width

            const reducedWidth = 8;
            const reducedHeight = 4;

            const xPosition = pageWidth - 24;
            const yPosition = pageHeight - reducedHeight - 2;

            doc.addImage(base64Image, 'JPEG', xPosition, yPosition, reducedWidth, reducedHeight);
          }
        }

        const addPageNumber = (doc: jsPDF, pageIndex: number) => {
          const pageHeight = doc.internal.pageSize.height;
          const pageWidth = doc.internal.pageSize.width;

          const totalPages = doc.internal.pages.length - 1;

          const pageNumberText = `Page ${pageIndex} of ${totalPages}`;

          const xPosition = pageWidth / 2 - doc.getTextWidth(pageNumberText) / 2;
          const yPosition = pageHeight - 2;

          doc.setFontSize(8);
          doc.text(pageNumberText, xPosition, yPosition);
        }

        doc.html(`<div class="js-pdf-wrapper">${response?.data}</div>`, {
          callback: async (doc: jsPDF) => {
            const totalPages = doc.internal.pages.length;

            for (let i = 1; i < totalPages; i++) {
              addFooterImage(doc, base64Image);
              doc.setPage(i);
              addPageNumber(doc, i);
            }

            const iframe = document.createElement('iframe');
            iframe.src = doc.output('bloburi')?.toString();
            iframe.setAttribute('style', 'width:100%;height:700px');

            if (htmlRef.current) {
              htmlRef.current.innerHTML = '';
              htmlRef.current.appendChild(iframe);
              setIsLoadingTheRentalAgrement(true);
            }
          },
          margin: [6, 5, 7, 5],
          x: 0,
          y: 0,
          width: 200,
          windowWidth: 1024,
          filename: `RentalAgreement${reservationId}.pdf`,
          autoPaging: "text"
        });
        handleTenantError(null);
      } catch (error) {
        setIsLoadingTheRentalAgrement(true);
       handleTenantError(error);
      }
    }

    if (reservationId > 0) fetchAndConvertPdf();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryData, initialsURL]);

  const converTheBase64IntoFileAndUploadToServer = (canvas: HTMLCanvasElement, callback: any) => {
    if (!isCompletedOrCancelled) {
      canvas.toBlob((blob) => {
        if (blob) {
          const formData = new FormData();
          formData.append("ImageFile", blob, 'signature.png');
          axios
            .post(`${baseURL}reservationFile/upload`, formData, {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "multipart/form-data"
              },
              withCredentials: true,
            })
            .then((response) => {
              callback(response.data);
              handleTenantError(null);
            })
            .catch((error) => {
              handleTenantError(error);
              callback("");
            });
        } else {
          console.error("Error: Blob is null");
          callback("");
        }
      }, 'image/png');
    }
  }

  const uploadSignature = () => {
    if (!isCompletedOrCancelled) {
      setPleaseWaitPopup(true);
      let files: any[] = [];
      if (signatureURL) {
        if (signatureURL?.id > 0) {
          uploadInitial(files);
          signaturePadRef.current?.clear();
        } else {
          convertAndUploadTheSignature(files);
        }
      } else {
        convertAndUploadTheSignature(files);
      }
    }
  };

  const convertAndUploadTheSignature = (files: any[]) => {
    if (!isCompletedOrCancelled) {

      const canvas = signaturePadRef.current?.getTrimmedCanvas();
      if (canvas && (canvas.width > 1 && canvas.height > 1)) {
        converTheBase64IntoFileAndUploadToServer(canvas, (imageFilePath: string) => {
          if (imageFilePath) {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: imageFilePath,
              tabName: "Signature",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });

            uploadInitial(files);
            signaturePadRef.current?.clear();
          } else {
            uploadInitial(files);
          }
        });
      } else {
        uploadInitial(files);
      }
    }
  }

  const uploadInitial = (files: any[]) => {
    if (!isCompletedOrCancelled) {
      if (initialsURL) {
        if (initialsURL?.id > 0) {
          refreshTheAttachement();
          setPleaseWaitPopup(false);
          initialsPadRef.current?.clear();
        } else {
          convertAndUploadTheInitials(files);
        }
      } else {
        convertAndUploadTheInitials(files);
      }
    }
  };

  const convertAndUploadTheInitials = (files: any[]) => {
    if (!isCompletedOrCancelled) {
      const canvas = initialsPadRef.current?.getTrimmedCanvas();
      if (canvas && (canvas.width > 1 && canvas.height > 1)) {
        converTheBase64IntoFileAndUploadToServer(canvas, (imageFilePath: string) => {
          if (imageFilePath) {
            files.push({
              attributeName: "Reservation",
              attributeId: reservationId,
              fileName: imageFilePath,
              tabName: "Initials",
              userId: auth?.id ?? 0,
              createdDate: new Date(UpdateTimezone).toLocaleString()
            });

            initialsPadRef.current?.clear();
            confrimTheAgreement(files)


          } else {
            confrimTheAgreement(files)
          }
        });
      } else {
        confrimTheAgreement(files)
      }
    }
  }

  const confrimTheAgreement = (files: any) => {
    if (files?.length > 0) {
      confirmAgreement(
        files,
        reservationId,
        auth?.id,
        tenantId
      )
        .then(() => {
          refreshTheAttachement();
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch(error => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }
  }

  const deleteTheSignatureURL = async () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Delete Signature',
        summary: "Are you sure you want to delete this Signature?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          if (signatureURL?.id === 0) {
            setSignatureURL(null);
          } else {
            setPleaseWaitPopup(true);

            await delete_fileUpload(signatureURL?.id, auth?.id, tenantId)
              .then(() => {
                setSignatureURL(null);
                refreshTheAttachement();
                setPleaseWaitPopup(false);
                handleTenantError(null);
              })
              .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
              });
          }
          callback();
        }
      });
      setConfirmPopup(true);
    }
  };

  const deleteTheInitialsURL = async () => {
    if (!isCompletedOrCancelled) {
      setConfirmData({
        title: 'Delete Initials',
        summary: "Are you sure you want to delete this Initials?",
        confirmBtn: 'Yes',
        isConfirm: async (callback: any) => {
          if (initialsURL.id === 0) {
            setInitialsURL(null);
          } else {
            setPleaseWaitPopup(true);

            await delete_fileUpload(initialsURL?.id, auth?.id, tenantId)
              .then(() => {
                setInitialsURL(null);
                refreshTheAttachement();
                setPleaseWaitPopup(false);
                handleTenantError(null);
              })
              .catch((error) => {
                setPleaseWaitPopup(false);
                handleTenantError(error);
              });
          }
          callback();
        }
      });
      setConfirmPopup(true);
    }
  };

  const handleDisableEnableRenewal = () => {
    setConfirmData({
      title: summaryData?.isDisableRenewal ? 'Enable Renewal' : 'Disable Renewal',
      summary: summaryData?.isDisableRenewal ? 'Are you sure you want to enable renewal?' : 'Are you sure you want to disable renewal?',
      isConfirm: (callback: any) => {
        setPleaseWaitPopup(true);

        disableRenewal(
          reservationId,
          !summaryData?.isDisableRenewal,
          auth?.id,
          tenantId
        )
          .then(() => {
            refreshTheSummary();
            handleTenantError(null);
          })
          .catch(error => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });

        callback();
      }
    });

    setConfirmPopup(true);
  }

  return (
    <>
      <div className="w-full">
        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Contract
        </span>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <div className="w-full my-2 relative">
          {
            !isLoadingTheRentalAgrement && (
              <div className="w-full flex items-center justify-center mt-2">
                <CircularProgress size="20px" />
              </div>
            )
          }

          <div className="relative">
            <div className="w-full h-fit" ref={htmlRef}></div>
          </div>
        </div>

        <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
          Signatures
        </span>

        <Divider className={`w-full ${themeStyles.divider.bg}`} />

        <div className="w-full my-2 flex gap-2.5">
          <div className="w-1/2 select-none">
            <p className={`text-xs font-bold ${themeStyles.main.textHeadingColor}`}>Signature</p>

            {
              signatureURL
                ? (
                  <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                    <img src={`${baseURL}reservationFile/Get?name=${signatureURL?.fileName}`} alt="Signature" className="h-[150px]" />
                  </div>
                ) : (
                  <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                    <SignatureCanvas
                      ref={signaturePadRef}
                      penColor="#167AC3"
                      canvasProps={{
                        className: "w-full h-[150px]",
                      }}
                    />
                  </div>
                )
            }

            <div className="flex flex-row gap-1 mt-1">
              <i
                className="bx bxs-eraser text-lg bg-orange-500 text-white px-1.5 py-0.5 rounded cursor-pointer"
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    signaturePadRef.current?.clear();
                    if (signatureURL) deleteTheSignatureURL();
                  }
                }}
              ></i>
              <input
                type="file"
                accept="image/*"
                name="signatureFileRef"
                ref={signatureFileRef}
                onChangeCapture={onSignatureFileChangeCapture}
                className="hidden"
              />
              <i
                className="bx bx-upload text-lg bg-sky-400 text-white px-1.5 py-0.5 rounded cursor-pointer"
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    if (!signatureURL || signatureURL?.id === 0) {
                      signatureFileRef.current?.click();
                    } else {
                      setConfirmData({
                        title: "Warning",
                        summary: "Please remove this Signature first.",
                        confirmBtn: "Ok",
                        isConfirm: (callback: any) => {
                          callback();
                        },
                      });
                      setConfirmPopup(true);
                    }
                  }
                }}
              ></i>
            </div>
          </div>

          <div className="w-1/2 select-none">
            <p className={`text-xs font-bold ${themeStyles.main.textHeadingColor}`}>Initials</p>
            {
              initialsURL
                ? (
                  <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                    <img src={`${baseURL}reservationFile/Get?name=${initialsURL?.fileName}`} alt="Initials" className="h-[150px]" />
                  </div>
                ) : (
                  <div className="border border-dashed mt-2 border-gray-400 bg-no-repeat bg-center bg-auto">
                    <SignatureCanvas
                      ref={initialsPadRef}
                      penColor="#167AC3"
                      canvasProps={{
                        className: "w-full h-[150px]",
                      }}
                    />
                  </div>
                )
            }

            <div className="flex flex-row gap-1 mt-1">
              <i
                className="bx bxs-eraser text-lg bg-orange-500 text-white px-1.5 py-0.5 rounded cursor-pointer"
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    initialsPadRef.current?.clear();
                    if (initialsURL) deleteTheInitialsURL();
                  }
                }}
              ></i>
              <input
                type="file"
                accept="image/*"
                name="initialsFileRef"
                ref={initialsFileRef}
                onChangeCapture={onInitialsFileChangeCapture}
                className="hidden"
              />
              <i
                className="bx bx-upload text-lg bg-sky-400 text-white px-1.5 py-0.5 rounded cursor-pointer"
                onClick={() => {
                  if (!isCompletedOrCancelled) {
                    if (!initialsURL || initialsURL?.id === 0) {
                      initialsFileRef.current?.click();
                    } else {
                      setConfirmData({
                        title: "Warning",
                        summary: "Please remove this Inititals first.",
                        confirmBtn: "Ok",
                        isConfirm: (callback: any) => {
                          callback();
                        },
                      });
                      setConfirmPopup(true);
                    }
                  }
                }}
              ></i>
            </div>
          </div>
        </div>

        <div className="w-full my-3">
          <Button variant="contained"
            sx={{
              backgroundColor: "#039855",
              fontSize: "10px"
            }}
            onClick={uploadSignature}
          >
            Confirm the Agreement
          </Button>
        </div>

        {
          ((summaryData?.status === "Rental" || summaryData?.status === "ReOpen") &&
            currentPage === "Agreement") &&
          (auth?.roles?.toLowerCase()?.trim() === "admin" || (permissions?.extension ||
            permissions?.earlyreturn ||
            permissions?.replacevehicle ||
            permissions?.updatelocation ||
            permissions?.chargeoradjustment ||
            permissions?.disablerenewal)) &&
          (
            <div className="w-full my-2">
              <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Contract Modifications
              </span>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <div className="w-full my-3 flex gap-2.5">
                {
                  (permissions?.extension || auth?.roles?.toLowerCase()?.trim() === "admin") && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => {
                        if (!isCompletedOrCancelled) {
                          if (!summaryData?.isDisableRenewal) {
                            setAddExtensionIsOpen(true);
                          }
                        }
                      }}
                    >
                      Extension
                    </Button>
                  )
                }

                {
                  (permissions?.earlyreturn || auth?.roles?.toLowerCase()?.trim() === "admin") && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => {
                        if (!isCompletedOrCancelled) {
                          if (!summaryData?.isDisableRenewal) {
                            setAddEarlyReturnIsOpen(true);
                          }
                        }
                      }}
                    >
                      Early Return
                    </Button>
                  )
                }

                {
                  (permissions?.replacevehicle || auth?.roles?.toLowerCase()?.trim() === "admin") && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => {
                        if (!isCompletedOrCancelled) {
                          if (!summaryData?.isDisableRenewal) {
                            setReplaceVehicleIsOpen(!replaceVehicleIsOpen);
                          }
                        }
                      }}
                    >
                      Replace Vehicle
                    </Button>
                  )
                }

                {
                  (permissions?.updatelocation || auth?.roles?.toLowerCase()?.trim() === "admin") && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => {
                        if (!isCompletedOrCancelled) {
                          if (!summaryData?.isDisableRenewal) {
                            setUpdateLocationIsOpen(!updateLocationIsOpen)
                          }
                        }
                      }}
                    >
                      Update Location
                    </Button>
                  )
                }

                {
                  (permissions?.chargeoradjustment || auth?.roles?.toLowerCase()?.trim() === "admin") && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => {
                        if (!isCompletedOrCancelled) {
                          if (!summaryData?.isDisableRenewal) {
                            setAdjustmentIsOpen(true);
                          }
                        }
                      }}
                    >
                      Charge or Adjustment
                    </Button>
                  )
                }

                {
                  (permissions?.disablerenewal || auth?.roles?.toLowerCase()?.trim() === "admin") && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => handleDisableEnableRenewal()}
                    >
                      {summaryData?.isDisableRenewal ? 'Enable Renewal' : 'Disable Renewal'}
                    </Button>
                  )
                }

                {
                  (permissions?.disabledvehiclelocation || auth?.roles?.toLowerCase()?.trim() === "admin") && (
                    <Button variant="contained"
                      sx={{
                        backgroundColor: colorConfigs.btn.main.bg,
                        fontSize: "10px"
                      }}
                      onClick={() => setShareLocationIsOpen(true)}
                    >
                      Disabled Vehicle Location
                    </Button>
                  )
                }
              </div>
            </div>
          )
        }

        {
          reservationAdditionalCharge?.length > 0 && (
            <div className="w-full my-2">
              <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Adjustments
              </span>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <AdjustmentList
                adjustmentData={reservationAdditionalCharge}
                extraValue={extraValue}
                summaryData={summaryData}
                isCompletedOrCancelled={isCompletedOrCancelled}
                refreshTheSummary={() => {
                  refreshTheSummary();
                  refreshTheAdjustment();
                }}
                reservationId={reservationId}
                setPleaseWait={setPleaseWaitPopup}
              />
            </div>
          )
        }

        {
          extensionData?.length > 0 && (
            <div className="w-full my-2">
              <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Extension
              </span>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <ExtensionList
                extensionData={extensionData}
                setExtensionRefresh={setExtensionRefresh}
                formattedCreatedAt={formattedCreatedAt}
                isCompletedOrCancelled={isCompletedOrCancelled}
                setPleaseWait={setPleaseWaitPopup}
              />
            </div>
          )
        }

        {
          vehicleReplaceReport?.length > 0 && (
            <div className="w-full my-2">
              <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Vehicle Replacements
              </span>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <VehicleReplaceList
                vehicleReplaceReport={vehicleReplaceReport}
                refreshTheSummary={(value) => {
                  setVehicleReplaceRefresh(value);
                  refreshTheSummary();
                }}
                reservationId={reservationId}
                locationOptions={locationOptions}
                checkInFiles={checkInFiles}
                checkOutFiles={checkOutFiles}
                vehicleReplacementCheckOutFiles={vehicleReplacementCheckOutFiles}
                vehicleReplacementCheckInFiles={vehicleReplacementCheckInFiles}
                formattedCreatedAt={formattedCreatedAt}
                refreshTheAttachement={refreshTheAttachement}
                isCompletedOrCancelled={isCompletedOrCancelled}
                setPleaseWait={setPleaseWaitPopup}
              />
            </div>
          )
        }

        {
          earlyReturnData?.length > 0
          && (
            <div className="w-full my-2">
              <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Early Return
              </span>

              <Divider className={`w-full ${themeStyles.divider.bg}`} />

              <EarlyReturnList
                earlyReturnData={earlyReturnData}
                setEarlyReturnRefresh={setEarlyReturnRefresh}
                formattedCreatedAt={formattedCreatedAt}
                setPleaseWait={setPleaseWaitPopup}
              />
            </div>
          )
        }

        {
          disabledVehicleLocationData?.length > 0 && (
            <div
              className="overflow-x-auto"
              style={{
                scrollbarWidth: 'thin',
                WebkitOverflowScrolling: 'touch',
              }}
            >
              <div className="inline-block min-w-max my-2">
                <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                  Disable Vehicle Location
                </span>

                <Divider className={`w-full ${themeStyles.divider.bg}`} />

                <DisabledVehicleLocationList
                  disabledVehicleLocationData={disabledVehicleLocationData}
                  setShareLocationRefresh={setShareLocationRefresh}
                  isCompletedOrCancelled={isCompletedOrCancelled}
                  setPleaseWait={setPleaseWaitPopup}
                />
              </div>
            </div>
          )
        }

        {
          addEarlyReturnIsOpen && (
            <AddEarlyReturnModal
              addEarlyReturnIsOpen={addEarlyReturnIsOpen}
              setAddEarlyReturnIsOpen={setAddEarlyReturnIsOpen}
              summaryData={summaryData}
              setEarlyReturnRefresh={(value) => {
                setEarlyReturnRefresh(value);
                refreshTheSummary();
              }}
              locationOpenHourOfParticularBranch={locationOpenHourOfParticularBranch}
              formattedCreatedAt={formattedCreatedAt}
              reservationId={reservationId}
              preferredDateFormat={preferredDateFormat}
              setAvailableVehicle={setAvailableVehicle}
              setPleaseWait={setPleaseWaitPopup}
            />
          )
        }

        {
          adjustmentIsOpen && (
            <AddAdjustmentModal
              adjustmentIsOpen={adjustmentIsOpen}
              setAdjustmentIsOpen={setAdjustmentIsOpen}
              extraValue={extraValue}
              isCompletedOrCancelled={isCompletedOrCancelled}
              getDataFromExtras={getDataFromExtras}
              refreshTheSummary={() => {
                refreshTheSummary();
                refreshTheAdjustment();
              }}
              reservationId={reservationId}
              setPleaseWait={setPleaseWaitPopup}
            />
          )
        }

        {
          addExtensionIsOpen && (
            <AddExtensionModal
              addExtensionIsOpen={addExtensionIsOpen}
              setAddExtensionIsOpen={setAddExtensionIsOpen}
              setExtensionRefresh={(value) => {
                setExtensionRefresh(value);
                refreshTheSummary();
              }}
              summaryData={summaryData}
              locationOpenHourOfParticularBranch={locationOpenHourOfParticularBranch}
              formattedCreatedAt={formattedCreatedAt}
              reservationId={reservationId}
              preferredDateFormat={preferredDateFormat}
              setAvailableVehicle={setAvailableVehicle}
              setPleaseWait={setPleaseWaitPopup}
            />
          )
        }

        {
          replaceVehicleIsOpen && (
            <AddReplaceVehicleModal
              replaceVehicleIsOpen={replaceVehicleIsOpen}
              setReplaceVehicleIsOpen={setReplaceVehicleIsOpen}
              summaryData={summaryData}
              setVehicleReplaceRefresh={(value) => {
                setVehicleReplaceRefresh(value);
                refreshTheSummary();
                refreshTheAttachement();
              }}
              availableVehicleClass={availableVehicle}
              returnLocationOptionsOfParticularBranch={returnLocationOptionsOfParticularBranch}
              bookedVehicleData={bookedVehicleData}
              checkInFiles={checkInFiles}
              vehicleReplacementCheckInFiles={vehicleReplacementCheckInFiles}
              formattedCreatedAt={formattedCreatedAt}
              reservationId={reservationId}
              isCompletedOrCancelled={isCompletedOrCancelled}
              preferredDateFormat={preferredDateFormat}
              setPleaseWaitPopup={setPleaseWaitPopup}
            />
          )
        }

        {
          updateLocationIsOpen && (
            <UpdateLocationModal
              updateLocationIsOpen={updateLocationIsOpen}
              setUpdateLocationIsOpen={setUpdateLocationIsOpen}
              locationOptions={locationOptions}
              summaryData={summaryData}
              selectedVehicleClass={selectedVehicleClass}
              isCompletedOrCancelled={isCompletedOrCancelled}
              refreshTheSummary={refreshTheSummary}
              reservationId={reservationId}
              setPleaseWaitPopup={setPleaseWaitPopup}
            />
          )
        }

        {
          shareLocationIsOpen && (
            <ShareLocationRequest
              open={shareLocationIsOpen}
              onClose={() => setShareLocationIsOpen(false)}
              isCompletedOrCancelled={isCompletedOrCancelled}
              setPleaseWait={setPleaseWaitPopup}
              reservationId={reservationId}
              summaryData={summaryData}
              customerPhoneNumber={customerPhoneNumber}
              formattedCreatedAt={formattedCreatedAt}
              refreshTheShareLocationRequest={() => setShareLocationRefresh(true)}
            />
          )
        }
      </div >
    </>
  )
}